import React, { useRef } from "react";
import { DragSourceMonitor } from "react-dnd";

import { RichContentDisplay } from "@examspark/common-ui";
import { Stem } from "@examspark/types";

import { useDrag } from "../../hooks/useDnd";

export type DndItem = {
  type: string;
  id: string;
  gapId?: string;
  instanceId?: string;
  maxUsage?: number;
};

type TokenProps = {
  data: Stem.Option;
  useDragType: string;
  gapId?: string;
  instanceId?: string;
  onEnd?: (item: DndItem | undefined, monitor: DragSourceMonitor) => void;
  inline?: boolean;
};
const Token = (props: TokenProps) => {
  const ref = useRef(null);
  useDrag(ref, {
    item: {
      type: props.useDragType,
      id: props.data.id,
      gapId: props.gapId,
      instanceId: props.instanceId,
      maxUsage: props.data.maxUsage,
    },
    end: (item, monitor) => {
      props.onEnd?.(item, monitor);
    },
  });

  return (
    <div
      ref={ref}
      style={{
        display: "contents",
        fontSize: props.data.fontSize,
      }}
    >
      <RichContentDisplay
        className="item-player-token"
        content={props.data.body}
        inline={props.inline}
      />
    </div>
  );
};
export default Token;
